module.exports = __webpack_public_path__ + "static/media/hotel-large.b3362a0f.png";